import { LayoutDashboard, Map, Radar, TrendingUp, Users, ClipboardList, Gift, Truck, IdCard, ShieldCheck, Percent, Star, LifeBuoy,
  MessagesSquare, Package, Leaf, Award, Trophy, Newspaper, UserCog, Database, Scale, Target } from "lucide-react";

const ALL = ["admin", "employee", "support"];
const AE = ["admin", "employee"];
const AD = ["admin"];

export const GROUPS = [
  ["Command", [
    { key: "overview", label: "Overview", icon: LayoutDashboard, roles: [...ALL, "kyc"], sub: "Everything happening at Kindsaver, live" },
    { key: "map", label: "Live Map", icon: Map, roles: ALL, sub: "Customers, pickups and kabadiwalas on one map" },
    { key: "live", label: "Dispatch", icon: Radar, roles: ALL, badge: "dispatch_attention", sub: "Overdue pickups, missed pickups, partner routes and history" },
    { key: "forecast", label: "Demand Forecast", icon: TrendingUp, roles: ALL, sub: "Where and when pickups are coming" },
  ]],
  ["Customers & sales", [
    { key: "customers", label: "Customers", icon: Users, roles: ALL, sub: "Every household and business we serve" },
    { key: "bookings", label: "Bookings", icon: ClipboardList, roles: ALL, badge: "new_bookings", sub: "Confirm, assign and close pickups" },
    { key: "referrals", label: "Referrals", icon: Gift, roles: AE, sub: "Who invited whom and rewards to pay" },
  ]],
  ["Partners", [
    { key: "staff", label: "Partners", icon: Truck, roles: AD, sub: "Kabadiwala accounts, logins and vehicles" },
    { key: "partners", label: "Profiles & Docs", icon: IdCard, roles: ["admin", "kyc"], sub: "Licence, RC, insurance and service areas" },
    { key: "kyc", label: "KYC", icon: ShieldCheck, roles: ["admin", "support", "kyc"], badge: "kyc_pending", sub: "Verify customers and partners" },
    { key: "commission", label: "Commission", icon: Percent, roles: AD, sub: "Per-pickup fee and partner ledgers" },
    { key: "targets", label: "Daily Targets", icon: Target, roles: AD, sub: "Pickups per day for every partner or one by one" },
    { key: "ratings", label: "Ratings", icon: Star, roles: ALL, sub: "How customers rate our partners" },
  ]],
  ["Support", [
    { key: "complaints", label: "Support Desk", icon: LifeBuoy, roles: ALL, badge: "awaiting_reply", sub: "Complaints queue with SLA, priority and owner" },
    { key: "chats", label: "Pickup Chats", icon: MessagesSquare, roles: ALL, badge: "chats_waiting", sub: "Conversations on live bookings" },
  ]],
  ["Catalogue", [
    { key: "materials", label: "Materials & Rates", icon: Package, roles: AD, sub: "What we buy and the price per kg" },
    { key: "ctypes", label: "Customer Types", icon: Users, roles: AD, sub: "Choices under 'Who are you?'" },
    { key: "factors", label: "Impact Factors", icon: Leaf, roles: AD, sub: "CO₂, trees and water saved per kg" },
  ]],
  ["Growth", [
    { key: "rewards", label: "Rewards", icon: Award, roles: AE, sub: "Green Points store and redemptions" },
    { key: "prizes", label: "Referral Prizes", icon: Trophy, roles: AE, sub: "Monthly top-inviter prizes" },
    { key: "news", label: "News & Quiz", icon: Newspaper, roles: AE, sub: "Recycling news feed that powers the daily quiz" },
  ]],
  ["System", [
    { key: "team", label: "Team", icon: UserCog, roles: AD, sub: "Admin, employee, support and KYC logins" },
    { key: "data", label: "Data & Backup", icon: Database, roles: AD, sub: "Backups, restore and resets" },
    { key: "compliance", label: "Compliance", icon: Scale, roles: AD, sub: "Licences and legal reminders" },
  ]],
];

export const sectionsFor = (role) => GROUPS.flatMap(([, items]) => items).filter((s) => s.roles.includes(role));
